import WindowNew from './WindowNew'

export default WindowNew
// eslint-disable-next-line import/export
export * from './WindowNew'
